/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserWalletHistoryListRespVo } from './PageDataUserWalletHistoryListRespVo';
import {
    PageDataUserWalletHistoryListRespVoFromJSON,
    PageDataUserWalletHistoryListRespVoFromJSONTyped,
    PageDataUserWalletHistoryListRespVoToJSON,
    PageDataUserWalletHistoryListRespVoToJSONTyped,
} from './PageDataUserWalletHistoryListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserWalletHistoryListRespVo
 */
export interface ResponsePageDataUserWalletHistoryListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserWalletHistoryListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserWalletHistoryListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserWalletHistoryListRespVo}
     * @memberof ResponsePageDataUserWalletHistoryListRespVo
     */
    data?: PageDataUserWalletHistoryListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserWalletHistoryListRespVo interface.
 */
export function instanceOfResponsePageDataUserWalletHistoryListRespVo(value: object): value is ResponsePageDataUserWalletHistoryListRespVo {
    return true;
}

export function ResponsePageDataUserWalletHistoryListRespVoFromJSON(json: any): ResponsePageDataUserWalletHistoryListRespVo {
    return ResponsePageDataUserWalletHistoryListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserWalletHistoryListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserWalletHistoryListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserWalletHistoryListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserWalletHistoryListRespVoToJSON(json: any): ResponsePageDataUserWalletHistoryListRespVo {
    return ResponsePageDataUserWalletHistoryListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataUserWalletHistoryListRespVoToJSONTyped(value?: ResponsePageDataUserWalletHistoryListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserWalletHistoryListRespVoToJSON(value['data']),
    };
}

